<template>
  <el-table-column
    prop="source_storage.name"
    label="Átadó raktár"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.source_storage.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'source_storage',
  };
</script>
